import React , {useState} from 'react'
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
const Text = (props) => {
    const {value , onChange , label, name , Error} = props
    const [viewpass, setViewpass] = useState(false);
    return (
        <>
            <div className='Outer-Inputs'>
                <label style={{fontWeight:"700"}} >{label}</label>
                <div className='TextFileds inputFields ' style={{display:"flex"}}>
                    <input type="text" value={value} onChange={onChange} name={name}  className={`${viewpass ? "activate" : "notactivate"}`} autoComplete='off' />
                    <i className="icon" style={{margin:"12px"}}>
                  {viewpass ? (
                    <RemoveRedEyeIcon
                      onClick={(e) => setViewpass(!viewpass)}
                    ></RemoveRedEyeIcon>
                  ) : (
                    <VisibilityOffIcon
                      onClick={(e) => setViewpass(!viewpass)}
                    ></VisibilityOffIcon>
                  )}
                </i>
                </div>
                <p style={{ color: "red", }} className='Errors_list'>{Error}</p>
            </div>
        </>
    )
}

export default Text;
